'use client'

import { create } from 'zustand'
import { ModalProps } from '@/types/modal'

type ModalStackItem = {
  id: string
  props: ModalProps
}

type ModalStore = {
  // Stack delle modali per supportare modali annidate
  modalStack: ModalStackItem[]

  // Azioni
  openModal: (id: string, props?: ModalProps) => void
  closeModal: () => void
  closeAllModals: () => void

  // Selettori
  getActiveModal: () => ModalStackItem | null
}

export const useModalStore = create<ModalStore>((set, get) => ({
  modalStack: [],

  openModal: (id: string, props = {}) => {
    set((state) => ({
      modalStack: [...state.modalStack, { id, props }],
    }))
  },

  closeModal: () => {
    set((state) => ({
      modalStack: state.modalStack.slice(0, -1),
    }))
  },

  closeAllModals: () => {
    set({ modalStack: [] })
  },

  getActiveModal: () => {
    const { modalStack } = get()
    return modalStack.length > 0 ? modalStack[modalStack.length - 1] : null
  },
}))
